import React from 'react';

import Button from '@/core/components/Button';
import type { UpdateAction } from '@/core/lib/new-architecture/domain/donation.domain';
import { useRouterContext } from '@/core/lib/router/router.context';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface UpdateActionComponentProps {
  action: UpdateAction;
}

const UpdateActionComponent: React.FC<UpdateActionComponentProps> = ({ action }) => {
  const { t } = useTranslationContext(['common']);
  const { push } = useRouterContext();

  const href = new Routes.ModifyDonationRoute(action.donationId);

  return (
    <Button onClick={() => push(href)} variant="secondary" size="large" iconLeft="edit" isDisabled={action.isDisabled}>
      {t(action.text, { ns: 'common' })}
    </Button>
  );
};

export default UpdateActionComponent;
